// Generated by CoffeeScript 2.7.0
import DebounceInput from 'trunks/vue/admin/components/libs/debounce_input.js';

import GroupOptions from 'trunks/vue/admin/components/libs/group_options.js';

export var PopoverGroupOptions = Vue.extend({
  components: {
    'group-options': GroupOptions,
    'debounce-input': DebounceInput
  },
  template: `<div class='popover-select-content popover-group-options' :class='wrapperClass'>
  <div class='popover-select-header' v-if='needFilterInput'>
    <debounce-input :placeholder='optionsFilterPlaceholder'
                    :value='keyword'
                    @change='updateKeyword'
                    class='bordered'
                    ref='debounceInputRef'/>
  </div>
  <div class='popover-select-body'>
    <group-options :groupedOptions='groupedOptions'
                  :keyword='keyword'
                  :multiple='multiple'
                  @valueChanged='valueChangedFunc'
                  ref='groupedOptionsRef'>
      <template slot='option-item-template' slot-scope='{ option }'>
        <slot name='option-item-template' :option='option'>
        </slot>
      </template>

      <template slot='filter-blankslate'>
        <slot name='filter-blankslate'></slot>
      </template>

      <template slot='options-blankslate'>
        <slot name='options-blankslate'></slot>
      </template>
    </group-options>
  </div>

  <div class='popover-select-footer' v-if='needFooter'>
    <div class='btn text-btn' @click.stop='cancelFunc'>取消</div>
    <div class='btn text-btn' @click.stop='submitFunc'>确认</div>
  </div>
</div>`,
  props: {
    wrapperClass: {
      type: [String, Array]
    },
    optionsFilterPlaceholder: {
      type: String,
      default: '输入关键字'
    },
    initialSelectedOptionIds: {
      type: Array
    },
    optionsUrl: {
      type: String,
      default: ''
    },
    formatDataFunc: {
      type: Function,
      required: true
    },
    needFilterInput: {
      type: Boolean,
      default: true
    },
    needFooter: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      groupedOptions: [],
      selectedOptionIds: _.clone(this.initialSelectedOptionIds),
      keyword: ''
    };
  },
  computed: {
    selectedOptions: function() {
      return _.chain(this.groupedOptions).map(function(groupOptions) {
        return _.filter(groupOptions.options, function(option) {
          return option._selected;
        });
      }).filter(function(option) {
        return option.length;
      }).flatten().value();
    }
  },
  watch: {
    groupedOptions: function(new_value, old_value) {
      return this.$emit('optionsChanged', new_value, old_value);
    },
    initialSelectedOptionIds: function() {
      return this.selectedOptionIds = _.clone(this.initialSelectedOptionIds);
    }
  },
  mounted: function() {
    return this.fetchGroupedOptions();
  },
  methods: {
    fetchGroupedOptions: function() {
      if (_.isEmpty(this.optionsUrl)) {
        return this.groupedOptions = this._formatGroupOptions(this.formatDataFunc());
      } else {
        return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.adminUrlFor(this.optionsUrl), {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          success: (data, xhr) => {
            return this.groupedOptions = this._formatGroupOptions(this.formatDataFunc(data));
          }
        });
      }
    },
    updateGroupedOptions: function(groupedOptions) {
      return this.groupedOptions = this._formatGroupOptions(groupedOptions);
    },
    selectedOptionsChanged: function(new_selected_ids) {
      this.selectedOptionIds = new_selected_ids;
      return this.updateGroupedOptions(this.groupedOptions);
    },
    reset: function() {
      this.updateKeyword('');
      this.selectedOptionIds = _.clone(this.initialSelectedOptionIds);
      return this.fetchGroupedOptions();
    },
    updateKeyword: function(value) {
      this.keyword = value;
      return this.$emit('keywordUpdated', this.keyword);
    },
    valueChangedFunc: function(_vm, option) {
      this.selectedOptionIds = option._selected ? _.union(this.selectedOptionIds, [option.id]) : _.without(this.selectedOptionIds, option.id);
      return this.$emit('valueChanged', option);
    },
    cancelFunc: function() {
      return this.$emit('cancelClicked');
    },
    submitFunc: function() {
      return this.$emit('submitClicked', this.selectedOptionIds);
    },
    _formatGroupOptions: function(grouped_options) {
      return _.each(grouped_options, (group) => {
        group.multiple = true;
        return _.each(group.options, (option) => {
          return Vue.set(option, '_selected', _.contains(this.selectedOptionIds, option.id));
        });
      });
    }
  }
});

export var PopoverGroupOptionsMixin = {
  components: {
    'popover-group-options': PopoverGroupOptions
  },
  data: function() {
    return {
      selectedGroupOptionIds: [],
      selectedGroupOptions: []
    };
  },
  created: function() {
    return this.selectedGroupOptionIds = this.initialSelectedTagIds;
  },
  methods: {
    reset: function() {
      return this.$refs.popoverGroupOptionsRef.reset();
    },
    cancelFunc: function() {
      return this.$emit('cancelClicked');
    },
    valueChangeFunc: function() {
      this.selectedGroupOptionIds = this.$refs.popoverGroupOptionsRef.selectedOptionIds;
      this.selectedGroupOptions = this.$refs.popoverGroupOptionsRef.selectedOptions;
      return this.$emit('valueChanged', this.selectedGroupOptionIds);
    },
    submitFunc: function() {
      return this.$emit('submitClicked', this.selectedGroupOptionIds, this.selectedGroupOptions);
    },
    optionsChangedFunc: function(new_value, old_value) {
      return this.$nextTick(function() {
        return this.$emit('optionsChanged', new_value, old_value);
      });
    }
  }
};

export default PopoverGroupOptions;
